'use client';

import { createContext, useContext, type ReactNode } from 'react';

interface PublicConfig {
  googleMapsApiKey: string;
  appUrl: string;
}

const ConfigContext = createContext<PublicConfig>({
  googleMapsApiKey: '',
  appUrl: '',
});

export function ConfigProvider({ config, children }: { config: PublicConfig; children: ReactNode }) {
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export function usePublicConfig() {
  return useContext(ConfigContext);
}
